// cSpell:enableCompoundWords
import GameAdminPanel from 'components/gameadmin/GameAdminPanel';
import IconButton from 'components/iconbutton/IconButton';
import AddUserIcon from 'components/icons/AddUserIcon';
import GamesIcon from 'components/icons/GamesIcon';
import LockIcon from 'components/icons/LockIcon';
import DribbleIcon from 'components/icons/svg/DribbleIcon';
import TimeLapseIcon from 'components/icons/TimeLapseIcon';
import UnlockIcon from 'components/icons/UnlockIcon';
import { getDate30SecondsFromNow } from 'helpers/ArrayHelpers';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import React from 'react';
import { doLockBoard, doUpdateStartingActiveGameTime, getIsActiveSqGameBoardLocked } from 'slices/ActiveGameSlice';
import { ModalKind, setModal } from 'slices/SqModalSlice';

type GameAdminProps = {
  className?: string;
};

const GameAdmin: React.FC<GameAdminProps> = ({ className = '' }) => {
  const dispatch = useAppDispatch();
  const boardLocked = useAppSelector(getIsActiveSqGameBoardLocked);

  const endGameCountdown = () => dispatch(doUpdateStartingActiveGameTime(getDate30SecondsFromNow().getTime()));
  const showJoinGamePanel = () => dispatch(setModal({ kind: ModalKind.ShowJoinGameModal, isVisible: true }));
  const lockPicks = () => dispatch(doLockBoard(!boardLocked));
  const showScoreManager = () => dispatch(setModal({ kind: ModalKind.ShowScoreManager, isVisible: true }));
  const showScoreManagerCf = () => dispatch(setModal({ kind: ModalKind.ShowScoreManagerCf, isVisible: true }));
  // const showFixGame = () => dispatch(doFixGame(true));

  return (
    <GameAdminPanel className={className}>
      <IconButton onClick={endGameCountdown} title="Hurry Countdown To Start Game">
        <TimeLapseIcon size={40} />
      </IconButton>
      <IconButton onClick={showJoinGamePanel} title="Add Player To Game">
        <AddUserIcon size={40} />
      </IconButton>
      <IconButton onClick={lockPicks} selected={boardLocked} title="Lock Game">
        {boardLocked ? <LockIcon size={40} color="#000000" circleStrokeColor="#000000" /> : <UnlockIcon size={40} />}
      </IconButton>
      <IconButton onClick={showScoreManager} title="Show Game Score Manager">
        <GamesIcon size={40} />
      </IconButton>
      <IconButton onClick={showScoreManagerCf} title="Show Game Score Manager for Cloud Func">
        <DribbleIcon size={40} />
      </IconButton>
      {/* <IconButton onClick={showFixGame} title="Fix Game (print state only)">
        <RulerIcon size={40} />
      </IconButton> */}
    </GameAdminPanel>
  );
};

export default GameAdmin;
